import { Component } from '@theme/component';

/**
 * Parallax Showcase 组件
 * 简化版：使用 IntersectionObserver 监听图片进入可视区域
 * 当图片进入可视区域时，给内容容器添加 active 类
 * @extends {Component}
 */
export class ParallaxShowcase extends Component {
  requiredRefs = [];

  connectedCallback() {
    super.connectedCallback();
    
    // 确保DOM完全加载后再初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      requestAnimationFrame(() => this.init());
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    // 清理 IntersectionObserver
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  init() {
    // 移动端不执行
    if (window.innerWidth < 750) {
      return;
    }

    // 获取所有 block
    this.blocks = Array.from(this.querySelectorAll('.parallax-block'));
    if (this.blocks.length === 0) return;

    // 创建 IntersectionObserver
    const options = {
      root: null, // 视口作为根元素
      rootMargin: '0px',
      threshold: 0.3, // 当 30% 的元素可见时触发
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const block = entry.target;
        const content = block.querySelector('.parallax-block__content');
        
        if (!content) return;

        if (entry.isIntersecting) {
          // 图片进入可视区域，添加 active 类
          content.classList.add('active');
        } else {
          // 图片离开可视区域，移除 active 类
          content.classList.remove('active');
        }
      });
    }, options);

    // 监听每个 block
    this.blocks.forEach((block) => {
      this.observer.observe(block);
    });
  }
}

if (!customElements.get('parallax-showcase-component')) {
  customElements.define('parallax-showcase-component', ParallaxShowcase);
}

